import React from "react";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function FinalDestinationWarning() {
  return (
    <Warning>
      For international shipments, please fill out Final Destination fields.
    </Warning>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/FinalDestination/FinalDestinationWarning.jsx